import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_KEY, SUPABASE_URL } from './env';

/** What the app needs from Supabase (a real client satisfies it; tests pass a fake). */
export type AdminSupabase = Pick<SupabaseClient, 'auth' | 'rpc' | 'functions'>;

export function createSupabase(): SupabaseClient {
  return createClient(SUPABASE_URL, SUPABASE_KEY, {
    auth: {
      // Web OAuth: Google sends the browser back with `?code=...`; the client exchanges it and
      // keeps the session in this browser's localStorage.
      flowType: 'pkce',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}
